const productVariantIds = {
  monthly: {
    saga1: 46060371017986,
    saga2: 44099353444610,
    saga3: 44103507345666,
    saga4: 44103507575042,
  },
  annual: {
    saga1: 46054529499394,
    saga2: 44099388145922,
    saga3: 44099388473602,
    saga4: 44103595852034,
  },
};
const sellingPlanIds = {
  monthlySellingPlanId: 3010134274,
  annualSellingPlanId: 3010167042,
  monthlyWShipping: 3039756546,
  annualWShipping: 3039756546,
};

const updateCartDrawer2 = (sections) => {
  let cartDrawerEl = document.querySelector("#CartDrawer");
  let html = new DOMParser()
    .parseFromString(sections["cart-drawer"], "text/html")
    .querySelector("#CartDrawer").innerHTML;
  cartDrawerEl.innerHTML = html;
  let bubbleEl = document.querySelector("#cart-icon-bubble");
  bubbleEl.innerHTML = sections["cart-icon-bubble"];
};

$(".fibc-product__plan-block").click((e) => {
  var blockContainer = e.currentTarget.parentElement;
  var openElement = $(".fibc-product__info-open");

  if (!blockContainer.classList.contains("fibc-product__info-open")) {
    $(".fibc-product__info-open .fibc__plan-select").removeAttr("ischecked");
    openElement.removeClass("fibc-product__info-open");
    blockContainer.classList.add("fibc-product__info-open");
    $(".fibc-product__info-open .fibc__plan-select").click();
    $(".fibc-product__info-open .fibc__plan-select").attr("ischecked", "true");

    const sagaSelectEl = document.querySelector(".fibc-saga-select__options");
  }
});

const addItemsToCart = async (formData, buttonEl) => {
  let customOrderTag = buttonEl.target.getAttribute("aria-custom-order-tag");
  if (customOrderTag) {
    formData.items[formData.items.length - 1].properties._custom_order_tag =
      customOrderTag;
    if (customOrderTag.includes("FMF"))
      formData.items[formData.items.length - 1].properties._move_to_S1B1 =
        "Move to S1B1";
  }

  try {
    buttonEl.target.innerHTML = "adding...";
    buttonEl.target.setAttribute("disabled", "");

    const mainItem = formData.items[formData.items.length - 1];
    const freeItems = formData.items.slice(0, -1);

    // 1. Quietly add free items first
    if (freeItems.length > 0) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: freeItems }),
      });
    }

    // 2. Add main item and request updated cart drawer sections
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [mainItem],
        sections: ['cart-drawer', 'cart-icon-bubble'],
      }),
    });
    const parsedState = await response.json();

    // 3. Render and open the Dawn cart drawer
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && parsedState.sections) {
      cartDrawer.renderContents(parsedState);
    }

    buttonEl.target.innerHTML = "Added";
    buttonEl.target.removeAttribute("disabled");

  } catch (e) {
    console.error(e);
    window.location.reload();
  }
};

// The gift products (Welcome Package, bonus books) are added by the EasyGift app,
// not by this theme. That app is entirely client-side: it patches fetch/XHR to
// watch cart mutations and only ever runs on a rendered storefront page. Adding
// via a hard redirect to /cart/add?…&return_to=/checkout renders no such page, so
// its rules never fire and the gifts are silently missing from the order. Add via
// /cart/add.js instead — the same call the cart-drawer flow makes, which the app
// does see — then give it a moment to inject its lines before leaving for
// checkout.
const EASYGIFT_GIFT_HANDLE = "welcome-package";
const EASYGIFT_WAIT_MS = 2000;
const EASYGIFT_POLL_MS = 150;

// Legacy redirect-based add, kept as the fallback path only.
const buildCartAddPath = (formData) => {
  const cartAddParams = formData.items.map(item => {
    let parts = [
      `items[][id]=${item.id}`,
      `items[][quantity]=${item.quantity}`,
    ];
    if (item.selling_plan) {
      parts.push(`items[][selling_plan]=${item.selling_plan}`);
    }
    return parts.join("&");
  }).join("&");

  return `/cart/add?${cartAddParams}&return_to=/checkout`;
};

// Resolves as soon as EasyGift has added its gift line, or on timeout — a missing
// gift must never hold the buyer back from checkout.
//
// `handle` is which product to wait for, and defaults to the Welcome Package so
// every existing caller behaves exactly as before. Pages whose offer gifts
// something else pass their own handle via data-gift-handle on the ATC button:
// waiting for a product the offer never adds can only ever run to the full
// EASYGIFT_WAIT_MS timeout, silently taxing every checkout on that page by 2s.
// Passing `false` skips the wait entirely, for offers with no EasyGift line at all.
const waitForEasyGift = async (handle) => {
  const giftHandle = handle === undefined ? EASYGIFT_GIFT_HANDLE : handle;
  if (!giftHandle) return false;
  const deadline = Date.now() + EASYGIFT_WAIT_MS;
  while (Date.now() < deadline) {
    await new Promise((resolve) => setTimeout(resolve, EASYGIFT_POLL_MS));
    try {
      const cart = await fetch("/cart.js", { cache: "no-store" }).then((r) => r.json());
      if (cart.items.some((item) => item.handle === giftHandle)) return true;
    } catch (e) {
      // Keep polling until the deadline.
    }
  }
  return false;
};

const sendToCheckout = async (formData, discount, giftHandle) => {
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: formData.items }),
    });
    if (!response.ok) throw new Error(`/cart/add.js responded ${response.status}`);

    await waitForEasyGift(giftHandle);

    // Wrap in /discount/CODE so the code applies on the way to checkout.
    window.location.href = discount
      ? `/discount/${discount}?redirect=/checkout`
      : "/checkout";
  } catch (e) {
    console.error(e);
    // Fall back to the original redirect-based add so a failure here can never
    // block checkout. The gifts will be missing, but the order still goes through.
    const redirectPath = buildCartAddPath(formData);
    window.location.href = discount
      ? `/discount/${discount}?redirect=${encodeURIComponent(redirectPath)}`
      : redirectPath;
  }
};

const customSagaSelect = (e) => {
  let optionsEl = document.querySelector(".fibc-saga-select__options");
  if (optionsEl) {
    let sagaValue = optionsEl.value,
      planSelect = optionsEl.getAttribute("aria-plan-select"),
      vid = productVariantIds[planSelect][sagaValue];
    e.items[e.items.length - 1].id = vid;
  }
  return e;
};

const getFreeProductData = async (e) => {
  let t = e.getAttribute("freeBookHandle"),
    a,
    r;
  if (t) {
    try {
      await $.getJSON(
        window.Shopify.routes.root + "products/" + t + ".js",
        function (e) {
          (a = e.variants[0].id), (r = e.variants[0].sku);
        }
      );
    } catch (o) {
      console.log(o);
    }
    return { freeBookVid: a, freeBookSku: r };
  } else {
    return false;
  }
};

const setFormData = (formData, variantId, sellingPlan, tag) => {
  formData.items.push({
    quantity: 1,
    id: variantId,
    form_type: "product",
  });
  if (sellingPlan)
    formData.items[formData.items.length - 1].selling_plan = sellingPlan;
  if (tag)
    formData.items[formData.items.length - 1].properties = {
      _free_book_vid: tag,
    };
};

var fibcAtcElements = document.getElementsByClassName(
  "fibc-product__atc-submit"
);
for (i = 0; i <= fibcAtcElements.length - 1; i++) {
  fibcAtcElements[i].addEventListener("click", async (e) => {
    // Change button text
    e.target.innerHTML = "adding...";
    e.target.setAttribute("disabled", "");

    let selectedEl = document.querySelector(
      ".fibc__plan-select[ischecked='true']"
    );
    let subId = parseInt(selectedEl.value);
    let freeProduct = await getFreeProductData(selectedEl);

    let formData = {
      items: [],
      sections: "cart-drawer,cart-icon-bubble",
    };
    // The free product that comes with monthly and annual
    if (freeProduct)
      setFormData(formData, freeProduct.freeBookVid, "", freeProduct.freeBookSku);
    // Another free book for pages that offer 2 free books
    if (selectedEl.dataset.freeBook)
      setFormData(formData, selectedEl.dataset.freeBook);

    // Paid add-ons bundled into a plan card (e.g. the Full Start card on the
    // first-month-free lander: Welcome Package + BRAVE+ lifetime). A
    // comma-separated list because a card can carry more than one, which
    // neither of the two single-value gift attributes above can express.
    // These are ordinary priced lines — nothing here discounts them.
    if (selectedEl.dataset.extraVariants) {
      selectedEl.dataset.extraVariants
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean)
        .forEach((id) => setFormData(formData, id));
    }

    // Selling plan resolution. data-selling-plan on the radio wins, so an offer
    // running on its own variant + SKIO plan (a free first month, a multi-book
    // tier) works without editing this file. The switch below is the fallback
    // for the two legacy variants, which carry no such attribute — and note
    // that it is a switch with no default: any OTHER variant reaching it gets
    // added with NO selling plan at all, i.e. as a one-time purchase rather
    // than a subscription, with no error anywhere. That is exactly the trap
    // data-selling-plan exists to avoid.
    if (selectedEl.dataset.sellingPlan) {
      setFormData(formData, subId, selectedEl.dataset.sellingPlan);
    } else {
      switch (subId) {
        case 46060371017986:
          // Monthly sub
          setFormData(formData, subId, sellingPlanIds.monthlySellingPlanId);
          break;
        case 46054529499394:
          // Annual sub
          setFormData(formData, subId, sellingPlanIds.annualSellingPlanId);
      }
    }

    formData = customSagaSelect(formData);

    // Branch: direct-to-checkout (optionally wrapped in /discount)
    if (e.target.dataset.toCheckout === "true") {
      const discount = e.target.dataset.discount || "";
      // data-gift-wait="false" skips the EasyGift poll; data-gift-handle names a
      // product other than the Welcome Package to wait for. Buttons with neither
      // pass undefined and keep the original default.
      const giftHandle =
        e.target.dataset.giftWait === "false"
          ? false
          : e.target.dataset.giftHandle || undefined;
      sendToCheckout(formData, discount, giftHandle);
      return;
    }

    // Default: open cart drawer via OCU flow
    addItemsToCart(formData, e);
  });
}

const checkForFreeBook = async (e, t) => {
  let a = e.getAttribute("freeBookHandle");
  if (a) {
    let r, o;
    try {
      await $.getJSON(
        window.Shopify.routes.root + "products/" + a + ".js",
        function (e) {
          (r = e.variants[0].id), (o = e.variants[0].sku);
        }
      );
    } catch (c) {
      console.log(c);
    }
    (t.items[0].properties = { _free_book_vid: o }),
      t.items.push({ quantity: 1, id: r, form_type: "product" });
  }
  return t;
};

for (
  var fibcMonthlyAtcElements =
      document.getElementsByClassName("fibc-monthly-atc"),
    i = 0;
  i <= fibcMonthlyAtcElements.length - 1;
  i++
)
  fibcMonthlyAtcElements[i].addEventListener("click", async (e) => {
    (e.target.innerHTML = "adding..."),
      e.target.setAttribute("disabled", ""),
      radioBtn &&
        "yes" == radioBtn.attr("isChecked") &&
        upsellListItem(onPageUpsellVid, onPageUpsellLineProperty);
    let selectedPlan = document.querySelector(".fibc__plan-select[checked]"),
      formData = {
        items: [
          {
            quantity: 1,
            id: selectedPlan.value,
            selling_plan: sellingPlanIds.monthlySellingPlanId,
            form_type: "product",
          },
        ],
        sections: "cart-drawer,cart-icon-bubble",
      };
    addItemsToCart(
      (formData = customSagaSelect(
        (formData = await checkForFreeBook(selectedPlan, formData))
      )),
      e
    );
  });